import React from "react";
import MediaTypeDisplay from "./MediaTypeDisplayComponent";
import { MediaAttachment } from "src/shared/types/src";

type iProps = { 
    media: MediaAttachment[] 
}

const FiveOrMoreAttachments: React.FC<iProps> = ({ media }) => {

    return (
        <div className="d-flex mx-n-4 media-collage-5 flex-wrap">
            <div className="pd-x-4">
                <div className="media-collage-item">
                    <MediaTypeDisplay media={media[0]} collageDisplay={true} />
                </div>
            </div>
            <div className="pd-x-4">
                <div className="media-collage-item">
                    <MediaTypeDisplay media={media[1]} collageDisplay={true} />
                </div>
            </div>
            <div className="pd-x-4">
                <div className="media-collage-item">
                    <MediaTypeDisplay media={media[2]} collageDisplay={true} />
                </div>
            </div>
            <div className="pd-x-4">
                <div className="media-collage-item">
                    <MediaTypeDisplay media={media[3]} collageDisplay={true} />
                </div>
            </div>
            <div className="pd-x-4">
                <div className="media-collage-item">
                    <MediaTypeDisplay media={media[4]} collageDisplay={true} />
                    {
                        (media.length > 5) ?
                        <div className="media-collage-count">
                            <span>+ { media.length - 5 }</span>
                        </div> : null
                    }
                </div>
            </div>
        </div>
    )
}

export default FiveOrMoreAttachments;